import { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const LandlordInformationContext = createContext({
  loading: null,
  error: null,
  landlordInformation: null
});

const LandlordInformationProvider = ({
  landlordInformation: initialLandlordInformation,
  children
}) => {
  const [landlordInformation] = useState(initialLandlordInformation);

  return (
    <LandlordInformationContext.Provider value={{ landlordInformation }}>
      {children}
    </LandlordInformationContext.Provider>
  );
};

LandlordInformationProvider.propTypes = {
  landlordInformation: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

export const useLandlordInformation = () =>
  useContext(LandlordInformationContext);

export default LandlordInformationProvider;
